import React  from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {colors} from '../../../style/constants.js';
import Grid from '@material-ui/core/Grid';
import InnerLinkButton from '../../../components/svgs/buttons/InnerLinkButton.js';
import { Link } from 'gatsby';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    position: 'relative',
    padding: 30,
    [theme.breakpoints.down('md')]: {
      padding: 15,
      [theme.breakpoints.down('sm')]: {
        padding: 5,
        [theme.breakpoints.down('xs')]: {
          padding: 2.5,
          marginBottom: 30
        },
      },
    },
    '& > div': {
      boxShadow: '0px 0px 15px 0px rgba(0,0,0,0.25)',
      borderRadius: 10,
      background: 'linear-gradient(to right, rgba(255,255,0,1) 0%,rgba(255,181,0,1) 100%)',
      padding: 30,
      boxSizing: 'border-box'
    },
    '& h2, h3': {
      color: colors.ATT_BLUE,
      textAlign: 'center',
      '& sup': {
        fontSize: '50%',
        verticalAlign: 'top',
        lineHeight: 1.75
      },
      '& span': {
        fontSize: '50%',
        marginLeft: 5
      }
    },
    '& h3': {
      margin: '7.5px 0 15px 0'
    }
  },
}));

const Partner = (props) => {
  const classes = useStyles();
  return (
    <Grid className={classes.wrapper} item xs={12} sm={12}>
      <Grid container direction='column' alignItems='center'>
      <h2>{props.lang === 'en-CA' ? 'Get your volume discount' : 'Obtenez votre rabais de volume'}</h2>
      <h3>{props.lang === 'en-CA' ? 'Become partner or reseller of our solution.' : 'Devenez partenaire ou revendeur de la solution.'}</h3>
      <Link to={props.lang === 'en-CA' ? '/en/contact-us' : '/nous-parler'}><InnerLinkButton text={props.lang === 'en-CA' ? 'Contact us' : 'Nous contacter'} /></Link>
      </Grid>
    </Grid>
  );
}

export default Partner;